

































































































































































































import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import LaporanKegiatanKlinikIgd, {
  KegiatanKlinikIgdResponse,
  selKey,
  ketKey
} from "@/services/LaporanKegiatanKlinikIgd";

@Component({})
export default class LaporanKegiatanKlinikIgdPage extends Vue {
  data: KegiatanKlinikIgdResponse | null = null;
  loading = false;
  saving = false;
  printing = false;

  tahun = moment().year();
  bulan = moment().month() + 1;

  draft: Record<string, number> = {};
  draftKet: Record<string, string> = {};
  berubah = false;

  bulanOptions = [
    { text: "Januari", value: 1 },
    { text: "Februari", value: 2 },
    { text: "Maret", value: 3 },
    { text: "April", value: 4 },
    { text: "Mei", value: 5 },
    { text: "Juni", value: 6 },
    { text: "Juli", value: 7 },
    { text: "Agustus", value: 8 },
    { text: "September", value: 9 },
    { text: "Oktober", value: 10 },
    { text: "November", value: 11 },
    { text: "Desember", value: 12 }
  ];

  get tahunOptions(): number[] {
    const kini = moment().year();
    const list: number[] = [];
    for (let t = kini; t >= kini - 5; t--) list.push(t);
    return list;
  }

  get kolomUrut(): string[] {
    if (!this.data) return [];
    return [...this.data.kolom_total_pasien, ...this.data.kolom_tidak_lanjut];
  }

  mounted(): void {
    this.muat();
  }

  async muat(): Promise<void> {
    this.loading = true;
    const res = await LaporanKegiatanKlinikIgd.get({
      tahun: this.tahun,
      bulan: this.bulan
    }).catch(() => null);
    if (res) this.terapkan(res);
    else this.data = null;
    this.loading = false;
  }

  async simpan(): Promise<void> {
    if (!this.data) return;
    this.saving = true;
    const res = await LaporanKegiatanKlinikIgd.save(
      { tahun: this.tahun, bulan: this.bulan },
      { ...this.draft, ...this.draftKet }
    ).catch(() => null);
    if (res) this.terapkan(res);
    this.saving = false;
  }

  async cetak(): Promise<void> {
    this.printing = true;
    await LaporanKegiatanKlinikIgd.openPdf({
      tahun: this.tahun,
      bulan: this.bulan
    }).catch(() => undefined);
    this.printing = false;
  }

  private terapkan(res: KegiatanKlinikIgdResponse): void {
    this.data = res;
    this.draft = { ...res.koreksi };
    this.draftKet = { ...res.ket };
    this.berubah = false;
  }

  nilaiRme(kKey: string, kol: string, gKey: string): number {
    if (!this.data) return 0;
    return this.data.rme[selKey(kKey, kol, gKey)] || 0;
  }

  nilai(kKey: string, kol: string, gKey: string): number {
    const key = selKey(kKey, kol, gKey);
    if (Object.prototype.hasOwnProperty.call(this.draft, key)) {
      return this.draft[key];
    }
    return this.nilaiRme(kKey, kol, gKey);
  }

  tampil(kKey: string, kol: string, gKey: string): string {
    const v = this.nilai(kKey, kol, gKey);
    return v > 0 ? String(v) : "";
  }

  dikoreksi(kKey: string, kol: string, gKey: string): boolean {
    const key = selKey(kKey, kol, gKey);
    return (
      Object.prototype.hasOwnProperty.call(this.draft, key) &&
      this.draft[key] !== this.nilaiRme(kKey, kol, gKey)
    );
  }

  tooltipSel(kKey: string, kol: string, gKey: string): string {
    return this.dikoreksi(kKey, kol, gKey)
      ? `Dikoreksi manual — hitungan RME: ${this.nilaiRme(kKey, kol, gKey)}`
      : "Angka dari data RME";
  }

  ubah(kKey: string, kol: string, gKey: string, ev: Event): void {
    const el = ev.target as HTMLInputElement;
    const bersih = el.value.replace(/[^0-9]/g, "");
    if (bersih !== el.value) el.value = bersih;

    const key = selKey(kKey, kol, gKey);
    const angka = bersih === "" ? 0 : parseInt(bersih, 10);

    if (angka === this.nilaiRme(kKey, kol, gKey)) {
      this.$delete(this.draft, key);
    } else {
      this.$set(this.draft, key, angka);
    }

    this.berubah = true;
  }

  ketNilai(kKey: string): string {
    return this.draftKet[ketKey(kKey)] || "";
  }

  ubahKet(kKey: string, ev: Event): void {
    const el = ev.target as HTMLInputElement;
    this.$set(this.draftKet, ketKey(kKey), el.value);
    this.berubah = true;
  }

  jumlahKolom(kol: string, gKey: string): number {
    const d = this.data;
    if (!d) return 0;
    return Object.keys(d.kategori).reduce(
      (t, kKey) => t + this.nilai(kKey, kol, gKey),
      0
    );
  }
}
